/**
 * @packageDocumentation
 * @module f1/string
 */

import to_regexp from '../to/to_regexp';

export interface MatchAll {
  /**
   * Find all occurrences of a regular expression in a string as an array of matches
   *
   * @public
   * @function f1.matchAll
   * @param regExp the regular expression to match again
   * @param s the string to search
   * @example
   *
   * ```ts
   * f1.matchAll(/[a|b]/g, 'ab') == [
   *   ['a', index: 0, input: 'a']
   *   ['b', index: 1, input: 'b']
   * ];
   * ```
   */
  (regExp: RegExp | string, s: string): RegExpMatchArray[];
  (regExp: RegExp | string): (s: string) => RegExpMatchArray[];
}

/**
 * @see MatchAll
 */
export default (regExp: RegExp | string, s: string) => {
  // @note we have to add global or the exec will spin out of control
  const re = to_regexp(regExp);
  const safeRe = re.flags.indexOf('g') >= 0 ? re : new RegExp(re.source, `${re.flags}g`);

  const matches = [];
  let result;
  while ((result = safeRe.exec(s)) != null) {
    matches.push(result);
  }

  return matches;
};
